/*
* VUEX 配置文件
*/
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  state: {
    houseId: '',
    seckillId: '',
    buyHouseType: '',
    buyListId: '',
    userData: JSON.parse(localStorage.getItem('ship_user')) || {},
    companyList: [],
		destinationList: [],
		portList: [],
    productList:[],
		countryList: [],
		transportmodeList: [],
		countryMap: new Map(),
  },
  getters: {
    getHouseId (state) {
      return state.houseId
    },
    getSeckillId (state) {
      return state.seckillId
    },
    getBuyHouseType (state) {
      return state.buyHouseType
    },
    getBuyListId (state) {
      return state.buyListId
    },
    companyList: state => state.companyList,
		destinationList: state => state.destinationList,
		portList: state => state.portList,
		countryList: state => state.countryList,
		transportmodeList: state => state.transportmodeList,
		countryMap: state => state.countryMap,
    productList:state=>state.productList
  },
  actions: {

  },
  mutations: {
    UPDATE_USER_DATA (state, data) {
      state.userData = data
    },
    setHouseId (state, id) {
      state.houseId = id
    },
    setSeckillId (state, id) {
      state.seckillId = id
    },
    setBuyHouseType (state, id) {
      state.buyHouseType = id
    },
    setBuyListId (state, id) {
      state.buyListId = id
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js